module.exports = __webpack_public_path__ + "static/media/library.f56e8a2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/library.jpg
// module id = 660
// module chunks = 1